import { createSelector } from 'reselect'

const domainControlSliceSelector = ({ organizationSettings }) => organizationSettings.domainControl

const createFormSelector = createSelector(
  domainControlSliceSelector,
  ({ createForm }) => createForm
)

const listSelector = createSelector(
  domainControlSliceSelector,
  ({ list }) => list
)

export const loadingSelector = createSelector(
  createFormSelector,
  ({ loading }) => loading
)

const isAnyPopupOpenSelector = createSelector(
  listSelector,
  ({ isPopupOpen }) => isPopupOpen
)

const openPopupTypeSelector = createSelector(
  listSelector,
  ({ openPopupType }) => openPopupType
)

export const isPopupOpenSelector = (popupType) => createSelector(
  isAnyPopupOpenSelector,
  openPopupTypeSelector,
  (isAnyPopupOpen, openPopupType) => isAnyPopupOpen && popupType === openPopupType
)

export const domainForPopupSelector = createSelector(
  listSelector,
  ({ domainForPopup }) => domainForPopup
)

export const isLoadingActionPopupSelector = createSelector(
  listSelector,
  ({ isLoadingActionPopup }) => isLoadingActionPopup
)

export const domainSelector = createSelector(
  createFormSelector,
  ({ domain }) => domain
)

export const verificationMethodSelector = createSelector(
  createFormSelector,
  ({ verificationMethod }) => verificationMethod
)

export const formDisabledSelector = createSelector(
  createFormSelector,
  ({ formDisabled }) => formDisabled
)

export const errorSelector = createSelector(
  createFormSelector,
  ({ error }) => error
)

export const domainsListSelector = createSelector(
  listSelector,
  ({ entries }) => entries
)

export const loadingVerificationsSelector = createSelector(
  listSelector,
  ({ loadingVerifications }) => loadingVerifications
)

export const expandedDomainCardsSelector = createSelector(
  listSelector,
  ({ expandedCardDomains }) => expandedCardDomains
)

export const allDomainSummariesSelector = createSelector(
  listSelector,
  ({ allDomainSummaries }) => allDomainSummaries
)

export const submitDisabledSelector = createSelector(
  createFormSelector,
  ({ submitDisabled }) => submitDisabled
)

export const domainErrorSelector = (domainControlUuid) => createSelector(
  listSelector,
  ({ errors }) => errors[domainControlUuid]
)

export const domainControlSettingSelector = createSelector(
  domainControlSliceSelector,
  ({ domainControlSetting }) => domainControlSetting
)

export const accessOwnerDropdownSelector = createSelector(
  domainControlSettingSelector,
  ({ accessOwnerDropdown }) => accessOwnerDropdown
)

export const reportGenerationStatusSelector = (domainControlUuid) => createSelector(
  listSelector,
  ({ reportGeneration }) => reportGeneration[domainControlUuid]
)

export const domainControlSettingLoadingSelector = createSelector(
  domainControlSettingSelector, ({ loading }) => loading
)
